import { THEMES, useTheme } from '@/store/useTheme';
import { useTranslation } from 'react-i18next';

import styles from './ThemeSwitcher.module.css';

/** Controle segmentado de tema (Claro / Escuro / Black) no header. */
export function ThemeSwitcher() {
  const { t } = useTranslation(['common', 'nav', 'board', 'articles', 'analytics', 'feeddrive', 'config', 'strategist']);
  const theme = useTheme((s) => s.theme);
  const setTheme = useTheme((s) => s.setTheme);

  return (
    <div className={styles.root} role="group" aria-label={t('common:labels.themeInterface', 'Tema da interface')}>
      {THEMES.map((t) => (
        <button
          key={t.value}
          type="button"
          className={`${styles.seg} ${theme === t.value ? styles.segActive : ''}`}
          aria-pressed={theme === t.value}
          onClick={() => setTheme(t.value)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
